import { ApiError, LogActivityError } from '../common/ApiError';
import { describeAxiosError } from '../common/api-message';

import { LoginError } from './api-functions';
import { debug } from '../utilities/debug-helper';
import isPromise from 'is-promise';
import { postErrorMessageNotistack } from '../actions/notistack-dispatcher-actions';

export const catchErrorMiddleware = (store) => (next) => (action) => {
  if (!isPromise(action?.payload)) {
    return next(action);
  } else {
    return next(action).catch((error) => {
      if (error instanceof LogActivityError) {
        debug.warn(
          'Error middleware - Activity Log api call error: ',
          error.getMessage(),
          error.getStatusCode()
        );
      } else if (error instanceof ApiError) {
        const apiErrorMessage = error.getMessage();
        const statusCode = error.getStatusCode();

        // Benign race: deleting several chat images quickly makes the API return
        // 200 with Success=false and no message (the item is already gone). There
        // is nothing actionable to show, so swallow it instead of logging noise
        // and flashing a bogus "Unknown error" toast. Real errors (any message,
        // or a non-200 status) still fall through below.
        if (!apiErrorMessage && statusCode === 200) {
          return;
        }

        debug.log('Error middleware - Api error catched', apiErrorMessage, statusCode);
        debug.dir(error);

        const errorMessage = error.getDisplayMessage();

        if (statusCode === 401) {
          store.dispatch(postErrorMessageNotistack(errorMessage, true));
        } else {
          store.dispatch(postErrorMessageNotistack(errorMessage));
        }
      } else if (error instanceof LoginError) {
        store.dispatch(postErrorMessageNotistack(error.message || 'Invalid username or password.'));
      } else {
        store.dispatch(postErrorMessageNotistack(describeAxiosError(error)));
        debug.log('Error middleware - catched unknwon error', error);
      }
    });
  } //endif not primise
};
